import { render } from "./OrderedView.vue?vue&type=template&id=3350d6d2&scoped=true"
import script from "./OrderedView.vue?vue&type=script&lang=js"
export * from "./OrderedView.vue?vue&type=script&lang=js"

import "./OrderedView.vue?vue&type=style&index=0&id=3350d6d2&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3350d6d2"]])

export default __exports__